let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("disGW")).then(() => parcelRequire('3kN5w'));